import classNames from 'classnames'
import { HTMLInputTypeAttribute } from 'react'
import { useField } from 'remix-validated-form'
import FormInputWrapper, { BaseInputClasses, FormInputWrapperProps } from './FormInputWrapper'
import { formatPhoneNumber } from 'app/formatPhoneNumber'

export type FormInputProps = {
  type?: HTMLInputTypeAttribute
  readOnly?: boolean
  readOnlyAsLabel?: boolean
  labelClassName?: string
  errorClassName?: string
} & FormInputWrapperProps<HTMLInputElement>

export default function FormPhone({
  name,
  label,
  type = `text`,
  placeholder,
  readOnly,
  cols,
  readOnlyAsLabel,
  wrapperClassName,
  className,
  labelClassName,
  errorClassName,
  newLineError,
  showErrorIcon,
  ...props
}: FormInputProps) {
  const { error, getInputProps } = useField(name)
  const inputClasses = classNames(
    className,
    BaseInputClasses,
    readOnly &&
      (readOnlyAsLabel
        ? `border-trn-200 shadow-elevation-1 read-only:cursor-not-allowed read-only:border-none read-only:p-0 read-only:shadow-none read-only:text-trn-500 read-only:focus:text-trn-500`
        : `border-trn-200 shadow-elevation-1 read-only:cursor-not-allowed read-only:border-gray-200 read-only:bg-trn-100 read-only:text-trn-500 read-only:focus:text-trn-500`),
  )

  let handleFormat = (event) => {
    let value = event.target.value
    event.target.value = formatPhoneNumber(value)
  }
  return (
    <>
      <FormInputWrapper
        {...{
          name,
          label,
          error,
          showErrorIcon,
          newLineError,
          cols,
          wrapperClassName,
          className: labelClassName ?? `text-ui-sm`,
          errorClassName,
        }}
      >
        <input
          {...getInputProps({ ...props, type: `tel`, placeholder, readOnly: readOnly, onBlur: handleFormat })}
          className={inputClasses}
        />
      </FormInputWrapper>
    </>
  )
}
